/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ChangeSetTitle } from './ChangeSetTitle';
import {
    instanceOfChangeSetTitle,
    ChangeSetTitleFromJSON,
    ChangeSetTitleFromJSONTyped,
    ChangeSetTitleToJSON,
} from './ChangeSetTitle';

/**
 * @type PropertyChangeSectionDtoTitle
 * 
 * @export
 */
export type PropertyChangeSectionDtoTitle = ChangeSetTitle;


export function PropertyChangeSectionDtoTitleFromJSON(json: any): PropertyChangeSectionDtoTitle {
    return PropertyChangeSectionDtoTitleFromJSONTyped(json, false);
}

export function PropertyChangeSectionDtoTitleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyChangeSectionDtoTitle {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...ChangeSetTitleFromJSONTyped(json, true) };
    return  ChangeSetTitleFromJSONTyped(json, true);
}

export function PropertyChangeSectionDtoTitleToJSON(value?: PropertyChangeSectionDtoTitle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfChangeSetTitle(value)) {
        return ChangeSetTitleToJSON(value as ChangeSetTitle);
    }

    return {};
}

/**
 * Check if a given object implements the PropertyChangeSectionDtoTitle interface.
 */
export function instanceOfPropertyChangeSectionDtoTitle(value: any): value is PropertyChangeSectionDtoTitle {
    if (instanceOfChangeSetTitle(value)) return true;
    return false;
}

